/* No variant regrouping, new pricing, cart API or product data mutations. */
(() => {
  'use strict';
  if (window.__gkPurchaseUx) return;
  window.__gkPurchaseUx = true;
  let root,observer,frame,bar;
  const text=(node,value)=>{if(node.textContent!==value)node.textContent=value;};
  function schedule(){if(!frame)frame=requestAnimationFrame(()=>{frame=0;render();});}
  function attach(){
    const next=document.querySelector('product-info.gk-purchase-ux');
    if(next===root)return;
    observer?.disconnect();root=next;
    if(root){observer=new MutationObserver(schedule);observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','value']});}
  }
  function bottomOffset(){
    let offset=88;
    const candidates=document.querySelectorAll('nav,footer,[class*="bottom"],[id*="bottom"],[class*="mobile-menu"]');
    for(const node of candidates){
      if(node===bar||bar.contains(node))continue;
      const r=node.getBoundingClientRect();
      if(getComputedStyle(node).position==='fixed'&&r.width>innerWidth*.6&&r.height>0&&r.height<180&&r.bottom>=innerHeight-12&&r.top<innerHeight)offset=Math.max(offset,innerHeight-r.top+8);
    }
    return offset;
  }
  function render(){
    attach();if(!root){bar.hidden=true;document.body.classList.remove('gk-purchase-bar-visible');return;}
    root.querySelector('.gk-offer-heading')?.remove();
    const total=root.querySelector('#genkidama-preis-live .gk-total-value');
    root.classList.toggle('gk-total-ready',Boolean(total?.textContent.trim()));
    const original=root.querySelector('button[name="add"][type="submit"]');
    const qty=root.querySelector('input[name="quantity"]');
    const modal=Array.from(document.querySelectorAll('dialog[open],cart-drawer.active,[role="dialog"][aria-modal="true"]:not([hidden])')).some(node=>node.getClientRects().length>0);
    const blocked=!original||original.disabled||original.getAttribute('aria-disabled')==='true';
    const validQuantity=Boolean(qty&&qty.checkValidity()&&Number(qty.value)>0);
    const shown=Boolean(innerWidth<750&&total&&original&&original.getBoundingClientRect().bottom<0&&!modal&&validQuantity);
    bar.hidden=!shown;
    document.body.classList.toggle('gk-purchase-bar-visible',shown);
    const button=bar.querySelector('button');button.disabled=blocked;
    text(button,blocked?'Derzeit nicht verfügbar':'In den Warenkorb');
    text(bar.querySelector('strong'),total?.textContent || '');
    text(bar.querySelector('small'),'Gesamt · '+(qty?.value || '1')+' Stück');
    if(shown)document.body.style.setProperty('--gk-purchase-bottom',bottomOffset()+'px');
  }
  function start(){
    if(!document.querySelector('product-info.gk-purchase-ux'))return;
    bar=document.createElement('div');bar.className='gk-purchase-bar';bar.hidden=true;
    bar.setAttribute('aria-label','Kaufübersicht');
    bar.innerHTML='<div class="gk-purchase-bar__price"><small></small><strong></strong></div><button type="button">In den Warenkorb</button>';
    document.body.append(bar);
    bar.querySelector('button').addEventListener('click',()=>{
      const original=root?.querySelector('button[name="add"][type="submit"]');
      const qty=root?.querySelector('input[name="quantity"]');
      if(!original||original.disabled||original.getAttribute('aria-disabled')==='true'||!qty?.checkValidity()||Number(qty.value)<=0)return;
      // Delegate to the original form, retaining inventory, preorder and consent rules.
      original.click();original.scrollIntoView({block:'center',behavior:'auto'});schedule();
    });
    document.addEventListener('change',schedule);document.addEventListener('input',schedule);
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
    document.addEventListener('shopify:section:load',schedule);
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
